// define a mixin object
/* eslint-disable */
import DialogOperationRunning from '@/components/DialogOperationRunning'
import DialogError from '@/components/DialogError'
import BreadCrumbs from '@/components/commons/BreadCrumbs'

import { Conf } from "../conf/defaults"

export default {
  components: {
    DialogOperationRunning,
    DialogError,
    BreadCrumbs
  },
  data() {
    return {
      operationRunningTitle: "INFO"
    };
  },
  created: function() {
    if (!this.$session.get("uuid")) {
      this.$router.push({ path: "/Login/" });
    } else {
      this.$store.dispatch("checkSession").then(
        (response) => {
          // Confronto del buildNo del client con quello pubblicato su iDempiere
          // (WebParam2): se il client è più vecchio, forza il refresh per caricare
          // la nuova versione. In sviluppo Conf.buildNo vale "DEV" (parseInt = NaN),
          // quindi il confronto è sempre falso e non disturba.
          let webParam2 =
            response && response.data ? response.data.webParam2 : null;
          if (webParam2 && parseInt(Conf.buildNo) < parseInt(webParam2)) {
            this.$session.clear();
            this.$session.destroy();
            this.$router.push({ path: "/Login/" });
            window.location.reload(true);
          }
        },
        () => {}
      );
    }
  },
  methods: {
    hello: function() {
      // console.log('******* hello from mixin! ******')
    },
    loginEffettuato(){
      if (this.$session.get("uuid") == null) return false;
      return true;
    }
  },
  computed: {
    progressMessage: function () {
      // console.log('progressMessage')
      return this.$store.state.progressMessage
    },
    progressMessageEnable: function () {
      // console.log('progressMessageEnable')
      if (this.$store.state.progressMessage == null) {
        return false
      } else {
        return true
      }
    },
    progressLoading: function(){
      return this.$store.state.progressLoading;
    },
    errorMessage: function () {
      return this.$store.state.errorMessage
    },
    errorMessageEnable: function() {
      if (this.$store.state.errorMessage == null) {
        console.log("errorMessageEnable --> false");
        return false;
      } else {
        console.log("errorMessageEnable --> true");
        return true;
      }
    },
    breadcrumbsitems: function () {
      return this.$store.state.breadcrumbsitems
    }
  }
};
